import { TableCell,TextOverflow } from "@forge/common";

const VmName = ({
  data,
  getMksToken,
}: {
  data: any;
  getMksToken: (data: any) => void;
}) => {
  return (
    <TableCell
      className={`text-sm vpp-table-border ${
        data && data.isPowerOn ? "light-blue" : ""
      } flex gap-5 truncate whitespace-nowrap`}
    >
      <div
        onClick={() => data && data.isPowerOn && getMksToken(data)}
        className={`${
          data && data.isPowerOn ? "cursor-pointer" : ""
        } text-inherit hover:none !text-sm xl-low:!text-[14px] xl-mid:!text-[18px] xl-high:!text-[24px] max-w-[5rem] truncate whitespace-nowrap block`}
      >
        <TextOverflow>{data && data.vmName ? data.vmName : "--"}</TextOverflow>
      </div>{" "}
    </TableCell>
  );
};

export default VmName
